import { buildFeltMediatorPrompt, callFeltMediator, buildRelationshipDataTextFromJourney } from '../utils/feltMediator';
import { i18n } from '../i18n';

export async function consultFeltMediatorService({
  mirrorData,
  name,
  partnerName,
  side1Animal,
  side1Gender,
  side2Animal,
  side2Gender,
  relation,
  numberOfSuggestions = 3,
  language = i18n?.language || 'en',
  fallbackPartnerName
}) {
  const relationshipDataText = buildRelationshipDataTextFromJourney({
    mirrorData,
    name,
    partnerName,
    side1Gender,
    side1Animal,
    side2Gender,
    side2Animal,
    relation
  });

  const prompt = buildFeltMediatorPrompt({
    relationshipDataText,
    numberOfSuggestions,
    existingSuggestions: [],
    shouldGenerateMirrorNameAndDescription: true,
    language
  });

  const response = await callFeltMediator({
    prompt,
    numberOfSuggestions,
    shouldGenerateMirrorNameAndDescription: true,
    fallbackPartnerName
  });

  const finalMirrorName = response.mirrorName || 'Relationship Conflict';
  const finalMirrorDescription = response.mirrorDescription ||
    "You and your friend had a disagreement that made both of you feel upset. This situation helped you learn more about each other's feelings and needs.";

  const suggestions = Array.isArray(response.suggestions)
    ? response.suggestions.map(s => ({ ...s, type: s.type || 'aiSuggestion' }))
    : [];

  return {
    suggestions,
    mirrorName: finalMirrorName,
    mirrorDescription: finalMirrorDescription,
    relationshipProblems: Array.isArray(response.relationshipProblems) ? response.relationshipProblems : [],
    raw: response
  };
}

export function persistAiSummary({ existingAISummary = {}, result }) {
  return {
    ...existingAISummary,
    suggestions: result.suggestions,
    mirrorName: result.mirrorName,
    mirrorDescription: result.mirrorDescription,
    relationshipProblems: result.relationshipProblems,
    userSuggestions: null
  };
}


